
export const apiRoute = process.env.REACT_APP_API_ROUTE
export const envGlob = process.env.NODE_ENV